enum NumberInputDisplayNames {
  NumberDecrementStepper = 'NumberDecrementStepper',
  NumberIncrementStepper = 'NumberIncrementStepper',
  NumberInput = 'NumberInput',
  NumberInputField = 'NumberInputField',
  NumberInputStepper = 'NumberInputStepper'
}

export default NumberInputDisplayNames;
